import axios from 'axios'
import apiRouter from './api-routes'

// axios.defaults.withCredentials = true

// Configuration globale de l'instance Axios
const http = axios.create({
  baseURL: apiRouter.baseURL
})

// Intercepteur de demande (Request Interceptor)
http.interceptors.request.use(
  (config) => {
    // Ajoutez ici votre logique de prétraitement des requêtes
    config.headers['x-api-key'] = 'HP9X6hH9n00mMVToKZxGWr12Olwczav4Pj5'

    return config
  },
  (error) => {
    // Gérez les erreurs de prétraitement des requêtes ici
    return Promise.reject(error)
  }
)

// Intercepteur de réponse (Response Interceptor)
http.interceptors.response.use(
  (response) => {
    // Ajoutez ici votre logique de prétraitement des réponses
    // Par exemple, vous pouvez gérer les réponses avant de les retourner aux composants

    return response
  },
  (error) => {
    // Gérez les erreurs de réponse ici
    return Promise.reject(error)
  }
)

export default http